// import firebase from 'firebase/compat/app';
// import 'firebase/compat/functions';
// import 'firebase/compat/firestore';
// import 'firebase/compat/database';
// import 'firebase/compat/auth';
import { getApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  updateCurrentUser,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator,
  getDocs,
  getDoc,
  collection,
  doc,
  query as fsQuery,
  where,
  onSnapshot,
  orderBy,
  startAfter,
  limit,
  limitToLast as firestoreLimitToLast,
} from "firebase/firestore";
import {
  getDatabase,
  off,
  ref,
  onValue,
  child,
  push,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  get,
  query as dbQuery,
  orderByKey,
  startAt,
  endAt,
  orderByValue,
  orderByChild,
  equalTo,
  limitToLast,
} from "firebase/database";
// import { getFunctions } from "firebase/functions";
import FirebaseConfig from "../helpers/FirebaseConfig.js";
import firebaseAxios from "../helpers/firebaseAxios.js";
import firebaseStorage from "../helpers/firebaseStorage.js";

class FirebaseSingleton {
  constructor(
    firebase,
    mainApp,
    auth,
    functions,
    firestore,
    database,
    fba,
    fbstore,
    tenant
  ) {
    this.firebase = firebase;
    this.mainApp = mainApp;
    //this.auth      = auth;
    this.functions = functions;
    this.firestore = firestore;
    //this.database  = database;
    //this.database  = database;
    this.fba = fba;
    this.fbstore = fbstore;
    this.tenant = tenant;
  }
  get auth() {
    const auth = getAuth(this.mainApp);
    if (!auth.signInWithEmailAndPassword) {
      Object.defineProperty(auth, "signInWithEmailAndPassword", {
        value: signInWithEmailAndPassword,
      });
    }
    if (!auth.getAuth) {
      Object.defineProperty(auth, "getAuth", {
        value: getAuth,
      });
    }
    if (!auth.signOut) {
      Object.defineProperty(auth, "signOut", {
        value: signOut,
      });
    }
    if (!auth.updateCurrentUser) {
      Object.defineProperty(auth, "updateCurrentUser", {
        value: updateCurrentUser,
      });
    }
    if (!auth.getCurrentUserFirstTime) {
      Object.defineProperty(auth, "getCurrentUserFirstTime", {
        get: () =>
          new Promise((resolve, reject) => {
            const unSuscribe = onAuthStateChanged(auth, (firebaseUser) => {
              unSuscribe();
              resolve(firebaseUser);
            });
          }),
      });
    }
    return auth;
    // return this.firebase,auth;
  }
  get database() {
    const database = getDatabase(this.mainApp);
    if (!database.ref) {
      Object.defineProperty(database, "ref", {
        value: (path) => {
          return ref(database, path);
        },
      });
    }
    if (!database.onValue) {
      Object.defineProperty(database, "onValue", {
        value: onValue,
      });
    }
    if (!database.get) {
      Object.defineProperty(database, "get", {
        value: get,
      });
    }
    if (!database.query) {
      Object.defineProperty(database, "query", {
        value: dbQuery,
      });
    }
    if (!database.orderByKey) {
      Object.defineProperty(database, "orderByKey", {
        value: orderByKey,
      });
    }
    if (!database.startAt) {
      Object.defineProperty(database, "startAt", {
        value: startAt,
      });
    }
    if (!database.orderByValue) {
      Object.defineProperty(database, "orderByValue", {
        value: orderByValue,
      });
    }
    if (!database.endAt) {
      Object.defineProperty(database, "endAt", {
        value: endAt,
      });
    }
    if (!database.onChildAdded) {
      Object.defineProperty(database, "onChildAdded", {
        value: onChildAdded,
      });
    }
    if (!database.onChildChanged) {
      Object.defineProperty(database, "onChildChanged", {
        value: onChildChanged,
      });
    }
    if (!database.onChildRemoved) {
      Object.defineProperty(database, "onChildRemoved", {
        value: onChildRemoved,
      });
    }
    if (!database.off) {
      Object.defineProperty(database, "off", {
        value: off,
      });
    }
    if (!database.orderByChild) {
      Object.defineProperty(database, "orderByChild", {
        value: orderByChild,
      });
    }
    if (!database.equalTo) {
      Object.defineProperty(database, "equalTo", {
        value: equalTo,
      });
    }
    if (!database.limitToLast) {
      Object.defineProperty(database, "limitToLast", {
        value: limitToLast,
      });
    }
    if (!database.getNewKey) {
      Object.defineProperty(database, "getNewKey", {
        value: async (path) => {
          const reference = ref(database);
          const newKey = push(child(reference, path)).key;
          return newKey;
        },
      });
    }
    if (!database.queryBuilder) {
      Object.defineProperty(database, "queryBuilder", {
        value: async (path, queryOptions = null) => {
          const reference = ref(database, path);
          const buildQuery = queryOptions
            ? dbQuery(reference, ...queryOptions)
            : dbQuery(reference);
          const snapshot = await get(buildQuery);
          return snapshot;
        },
      });
    }
    if (!database.queryBuilderListener) {
      Object.defineProperty(database, "queryBuilderListener", {
        value: (path, queryOptions = null, callback) => {
          const reference = ref(database, path);
          const buildQuery = queryOptions
            ? dbQuery(reference, ...queryOptions)
            : dbQuery(reference);
          return onValue(buildQuery, (querySnapshot) => {
            callback(querySnapshot);
          });
        },
      });
    }

    return database;
  }
  static firestoreObject(app) {
    let firestore;
    try {
      firestore = initializeFirestore(app, {
        localCache: persistentLocalCache({
          tabManager: persistentMultipleTabManager(),
        }),
      });
    } catch (e) {
      firestore = getFirestore(app);
    }
    if (process.env.VUE_APP_FIREBASE_ENV == "development") {
      const [host, port] = process.env.VUE_APP_FIRESTORE_DEV_HOST.split(":");
      connectFirestoreEmulator(firestore, host, port);
    }
    if (!firestore.collection) {
      Object.defineProperty(firestore, "collection", {
        value: (path) => {
          return collection(firestore, path);
        },
      });
    }
    if (!firestore.onSnapshot) {
      Object.defineProperty(firestore, "onSnapshot", {
        value: onSnapshot,
      });
    }
    if (!firestore.query) {
      Object.defineProperty(firestore, "query", {
        value: fsQuery,
      });
    }
    if (!firestore.where) {
      Object.defineProperty(firestore, "where", {
        value: where,
      });
    }
    if (!firestore.orderBy) {
      Object.defineProperty(firestore, "orderBy", {
        value: orderBy,
      });
    }
    if (!firestore.limit) {
      Object.defineProperty(firestore, "limit", {
        value: limit,
      });
    }
    if (!firestore.limitToLast) {
      Object.defineProperty(firestore, "limitToLast", {
        value: firestoreLimitToLast,
      });
    }
    if (!firestore.startAfter) {
      Object.defineProperty(firestore, "startAfter", {
        value: startAfter,
      });
    }
    if (!firestore.doc) {
      Object.defineProperty(firestore, "doc", {
        value: (path, id = null) => {
          if (id) {
            return doc(firestore, path, id);
          } else {
            return doc(firestore, path);
          }
        },
      });
    }
    if (!firestore.getDoc) {
      Object.defineProperty(firestore, "getDoc", {
        value: getDoc,
      });
    }
    if (!firestore.queryBuilderListener) {
      Object.defineProperty(firestore, "queryBuilderListener", {
        value: (path, queryOptions = null, callback) => {
          const reference = collection(firestore, path);
          const buildQuery = queryOptions
            ? fsQuery(reference, ...queryOptions)
            : fsQuery(reference);
          return onSnapshot(buildQuery, (querySnapshot) => {
            callback(querySnapshot);
          });
        },
      });
    }
    if (!firestore.queryBuilder) {
      Object.defineProperty(firestore, "queryBuilder", {
        value: (path, queryOptions = null) => {
          const reference = collection(firestore, path);
          const buildQuery = queryOptions
            ? fsQuery(reference, ...queryOptions)
            : fsQuery(reference);
          return getDocs(buildQuery);
        },
      });
    }
    return firestore;
  }
  static async getTenantApp() {
    const fireConf = new FirebaseConfig();
    let app = await fireConf.getApp(fireConf.getTenantInLocal());
    if (!app) {
      return await FirebaseSingleton.getTenantApp();
    }
    return app;
  }
  static async init() {
    if (!FirebaseSingleton.instance) {
      const fireConf = new FirebaseConfig();
      fireConf.firebaseInitMainApp();
      let mainApp;
      if (fireConf.getTenantInLocal()) {
        mainApp = await FirebaseSingleton.getTenantApp();
      } else {
        mainApp = await fireConf.getApp();
      }
      const fba = new firebaseAxios();
      fba.setTenant(fireConf.getTenantInLocal())
      const fbstore = new firebaseStorage();
      if (process.env.VUE_APP_FIREBASE_FUNCTIONS == "dev") {

        fba.useEmulator(process.env.VUE_APP_EMULATOR_IP);
      }

      //Objeto Auth
      const auth = getAuth();
      FirebaseSingleton.instance = new FirebaseSingleton(
        getApp(),
        mainApp,
        auth,
        null,
        FirebaseSingleton.firestoreObject(mainApp),
        getDatabase(),
        fba,
        fbstore,
        fireConf.getTenantInLocal()
      );
    }
    return FirebaseSingleton.instance;
  }
}

export { FirebaseSingleton };
